/**
 * NanoString "flipper" block script to trigger flip as the block enters viewport.
 *
 * We check to see if Motion One (https://motion.dev/) JS library is present (it should be if the GhostKit plugin is active).
 * If it is, we introduce a "flip when scrolled into view" animation to clue users in to the fact that the cards are hoverable
 * (or tappable in the case of mobile) -- it's not immediately obvious otherwise.
 */
const blockFlipper = {
	init() {
		if (typeof window.Motion.inView === 'function' && !window.flipperScroll) {
			document.querySelectorAll('.wp-block-nstg-flipper').forEach((el) => {
				el.classList.add('flipped');
			});
			window.Motion.inView('.wp-block-nstg-flipper', (info) => {
				info.target.classList.remove('flipped');
			}, { amount: 0.4 });
			window.flipperScroll = true;
		}
	},
};

blockFlipper.init();
